/*
 * HEADER
 *
 */
import React from 'react';
import Logo from '@/components/shared/Logo';
import Menu from '@/components/shared/Menu';
import '@/styles/components/header.scss';

const Header: React.FC = () => {
    
    return (
        <>
            <a href="#content" tabIndex={ 1 } className="screen-reader-text">Skip to main content</a>
            <header id="lm-header">
                <nav id="lm-navbar-top">
                    <div id="lm-navbar-top-menu" className="container">
                        <Menu name="social-nav" />
                        <Menu name="top-nav" />
                    </div>
                </nav>
                <nav id="lm-navbar-main" className="container">
                    <Logo id="lm-navbar-main-logo" />
                    <div id="lm-navbar-main-menu">
                        <Menu name="main-nav" />
                    </div>
                    { /* Mobile Open */ }
                    <button id="lm-navbar-toggle">
                        <span>Menu</span>
                    </button>
                </nav>
            </header>
        </>
    );
}
export default Header;